import vtkImplicitPlaneWidget from './ImplicitPlaneWidget';
import vtkInteractiveOrientationWidget from './InteractiveOrientationWidget';
import vtkPaintWidget from './PaintWidget';
import vtkPolyLineWidget from './PolyLineWidget';

export default {
  vtkImplicitPlaneWidget,
  vtkInteractiveOrientationWidget,
  vtkPaintWidget,
  vtkPolyLineWidget,
};
